import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {sidebarMenu_template} from "./sidebarMenu_template";

declare var ko: any;

export class suspiciousRules_template extends vnTemplate {

    public sidebarMenu: sidebarMenu_template;

    protected buildViewModel() {

        let self = this;

        return {
            brands: ko.observableArray([]),
            geos: ko.observableArray([]),
            rules: ko.observableArray([]),
            normalRules: ko.observableArray([]),
            selectedBrandId: ko.observable(null),
            lockedDevice: ko.observable('Desktop'),
            lockedReferrer: ko.observable('direct'),
            deviceAndReferrerLocked: ko.observable(true),
            deviceOptions: ko.observableArray([]),
            referrerOptions: ko.observableArray([]),
            brandRuleMinVisits: ko.observable(2),
            selectedRule: ko.observable(null),
            isCreateOpen: ko.observable(false),
            isEditOpen: ko.observable(false),
            create_device: ko.observable('Desktop'),
            create_referrer: ko.observable('direct'),
            create_geo: ko.observable(null),
            create_permalinkPattern: ko.observable(''),
            edit_device: ko.observable('Desktop'),
            edit_referrer: ko.observable('direct'),
            edit_geo: ko.observable(null),
            edit_permalinkPattern: ko.observable(''),
            generalError: ko.observable(null),
            permalinkError: ko.observable(null),
            openSidebar: function() {
                self.openSidebar();
            },
            onOpenCreate: function() {
                self.onOpenCreate();
            },
            onOpenEdit: function(rule) {
                self.onOpenEdit(rule);
            },
            onCloseCreate: function() {
                self.onCloseCreate();
            },
            onCloseEdit: function() {
                self.onCloseEdit();
            },
            onSubmitCreate: function() {
                self.onSubmitCreate();
            },
            onSubmitEdit: function() {
                self.onSubmitEdit();
            },
            onToggleRule: function(rule, event) {
                if (event) {
                    event.stopPropagation();
                }
                self.onToggleRule(rule);
            },
            onDeleteRule: function(rule, event) {
                if (event) {
                    event.stopPropagation();
                }
                self.onDeleteRule(rule);
            },
            formatGeos: function(geos) {
                return self.formatGeos(geos);
            },
            formatPermalink: function(permalinkPattern) {
                return self.formatPermalink(permalinkPattern);
            },
            formatDevice: function(device) {
                return self.formatDevice(device);
            },
            formatReferrer: function(referrer) {
                return self.formatReferrer(referrer);
            }
        };
    }

    public setSideMenuPermissionsData(data) {

        this.sidebarMenu.setData(data);
    }

    private openSidebar() {

        this.sidebarMenu.setSidebarToggle(true);
    }

    protected getTemplateName(): string {

        return 'suspiciousRules_template';
    }

    protected getMainElementClasses(): Array<string> {

        return ["page-content"];
    }

    public setReferences(data) {

        const brands = (data.brands || []).map(brand => Object.assign({}, brand, { id: String(brand.id) }));

        this.getTemplateViewModel().brands(brands);
        this.getTemplateViewModel().geos(data.geos || []);
        this.getTemplateViewModel().normalRules(data.normalRules || []);
        this.getTemplateViewModel().lockedDevice(data.lockedDevice || 'Desktop');
        this.getTemplateViewModel().lockedReferrer(data.lockedReferrer || 'direct');
        this.getTemplateViewModel().deviceAndReferrerLocked(data.deviceAndReferrerLocked !== false);
        this.getTemplateViewModel().deviceOptions(data.deviceOptions || []);
        this.getTemplateViewModel().referrerOptions(data.referrerOptions || []);
        this.getTemplateViewModel().brandRuleMinVisits(data.brandRuleMinVisits || 2);
        this.getTemplateViewModel().create_device(data.lockedDevice || 'Desktop');
        this.getTemplateViewModel().create_referrer(data.lockedReferrer || 'direct');

        if (!this.getSelectedBrandId() && brands.length > 0) {
            this.setSelectedBrandId(brands[0].id);
        } else {
            this.onBrandChange();
        }
    }

    public setRules(rules) {

        this.getTemplateViewModel().rules(rules || []);
    }

    public getSelectedBrandId() {

        return this.normalizeBrandId(this.getTemplateViewModel().selectedBrandId());
    }

    public setSelectedBrandId(idBrand) {

        const normalized = this.normalizeBrandId(idBrand);
        this.getTemplateViewModel().selectedBrandId(normalized ? String(normalized) : null);
    }

    public onBrandChange() {

        this.caller.onBrandChange();
    }

    public onOpenCreate() {

        this.clearErrors();
        this.getTemplateViewModel().create_device(this.getTemplateViewModel().lockedDevice());
        this.getTemplateViewModel().create_referrer(this.getTemplateViewModel().lockedReferrer());
        this.getTemplateViewModel().create_geo(null);
        this.getTemplateViewModel().create_permalinkPattern('');
        this.getTemplateViewModel().isCreateOpen(true);
    }

    public onOpenEdit(rule) {

        this.clearErrors();
        this.getTemplateViewModel().selectedRule(rule);
        this.getTemplateViewModel().edit_device(rule.device || this.getTemplateViewModel().lockedDevice());
        this.getTemplateViewModel().edit_referrer(rule.referrer || this.getTemplateViewModel().lockedReferrer());
        this.getTemplateViewModel().edit_geo(this.resolveGeoCode(rule.geos && rule.geos.length > 0 ? rule.geos[0] : null));
        this.getTemplateViewModel().edit_permalinkPattern(rule.permalinkPattern || '');
        this.getTemplateViewModel().isEditOpen(true);
    }

    public onCloseCreate() {

        this.getTemplateViewModel().isCreateOpen(false);
        this.getTemplateViewModel().create_device(this.getTemplateViewModel().lockedDevice());
        this.getTemplateViewModel().create_referrer(this.getTemplateViewModel().lockedReferrer());
        this.getTemplateViewModel().create_geo(null);
        this.getTemplateViewModel().create_permalinkPattern('');
        this.clearErrors();
    }

    public onCloseEdit() {

        this.getTemplateViewModel().isEditOpen(false);
        this.getTemplateViewModel().selectedRule(null);
        this.clearErrors();
    }

    public onSubmitCreate() {

        this.caller.onSubmitCreate();
    }

    public onSubmitEdit() {

        this.caller.onSubmitEdit();
    }

    public onToggleRule(rule) {

        this.caller.onToggleRule(rule);
    }

    public onDeleteRule(rule) {

        this.caller.onDeleteRule(rule);
    }

    public formatGeos(geos) {

        if (!geos || geos.length === 0) {
            return 'Any geo';
        }

        return geos.map(geo => this.getGeoLabel(geo)).join(', ');
    }

    public getGeoLabel(geo) {

        const option = this.findGeoOption(geo);

        return option ? option.name : geo;
    }

    public resolveGeoCode(geo) {

        if (!geo) {
            return null;
        }

        const option = this.findGeoOption(geo);

        return option ? option.codeName : geo;
    }

    public findGeoOption(geo) {

        return (this.getTemplateViewModel().geos() || []).find(item => item.codeName === geo || item.name === geo);
    }

    public getSelectedGeos() {

        const isEdit = this.getTemplateViewModel().isEditOpen();
        const geo = isEdit ? this.getTemplateViewModel().edit_geo() : this.getTemplateViewModel().create_geo();

        return geo ? [geo] : [];
    }

    public formatDevice(device) {

        const option = (this.getTemplateViewModel().deviceOptions() || []).find(item => item.value === device);
        return option ? option.label : (device || 'Desktop');
    }

    public formatReferrer(referrer) {

        const option = (this.getTemplateViewModel().referrerOptions() || []).find(item => item.value === referrer);
        if (option) {
            return option.label;
        }

        if (referrer === 'direct') {
            return 'Direct';
        }

        if (referrer === 'any') {
            return 'Any';
        }

        return referrer || 'Direct';
    }

    public formatPermalink(permalinkPattern) {

        if (!permalinkPattern) {
            return 'Any permalink';
        }

        return permalinkPattern;
    }

    public clearErrors() {

        this.getTemplateViewModel().generalError(null);
        this.getTemplateViewModel().permalinkError(null);
    }

    public getViewModelForRequest() {

        const isEdit = this.getTemplateViewModel().isEditOpen();

        return {
            id: isEdit ? this.getTemplateViewModel().selectedRule()?.id : null,
            idBrand: this.getSelectedBrandId(),
            device: isEdit ? this.getTemplateViewModel().edit_device() : this.getTemplateViewModel().create_device(),
            referrer: isEdit ? this.getTemplateViewModel().edit_referrer() : this.getTemplateViewModel().create_referrer(),
            geos: this.getSelectedGeos(),
            permalinkPattern: isEdit ? this.getTemplateViewModel().edit_permalinkPattern() : this.getTemplateViewModel().create_permalinkPattern(),
        };
    }

    protected getTemplateHtml(): string {

        return `
            <div class="page-header">
                <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
                <h2 style="display: none;" class="title-page">Suspicious Rules</h2>
            </div>

            <div class="nav-page-container">
                <div class="nav-page-grid">
                    <div class="nav-page-sidebar">
                        ` + this.sidebarMenu.getHtmlBuild() + `
                    </div>

                    <div id="suspiciousRules-results" class="nav-page-content">
                        <div class="block-default variation">
                            <span class="form-sub-title">Suspicious Rules</span>
                            <p class="form-text">
                                Suspicious IPs are flagged in two ways: global rules that always run on every brand, and optional brand-specific rules you add for one brand at a time.
                            </p>
                        </div>

                        <div class="suspicious-rules-columns">
                            <div class="block-default">
                                <span class="form-sub-title">Global rules</span>
                                <p class="form-text">
                                    These apply to every brand and cannot be changed here. They use a 2-day lookback. Matching IPs are marked suspicious for that brand.
                                </p>
                                <ul class="form-list">
                                    <!-- ko foreach: normalRules() -->
                                    <li>
                                        <strong data-bind="text: $data.title"></strong>
                                        <span data-bind="text: $data.description"></span>
                                    </li>
                                    <!-- /ko -->
                                </ul>
                            </div>

                            <div class="block-default">
                                <span class="form-sub-title">Brand specific suspicious rules</span>
                                <p class="form-text">
                                    Extra rules for one brand only. Geo and permalink are optional. Currently Desktop Direct traffic, 5-minute buckets over 2 days, <span data-bind="text: brandRuleMinVisits"></span> visits. If a brand has no rules here, only the global rules run.
                                </p>
                            </div>
                        </div>

                        <div class="list-results-header w-justify">
                            <div class="w-left">
                                <button type="button" data-bind="click: onOpenCreate, enable: selectedBrandId()" class="button-default icon i-add-2"><span>Add Rule</span></button>
                            </div>
                            <div class="w-center">
                                <div class="form-group">
                                    <label class="form-label">Brand</label>
                                    <div class="w-input">
                                        <select data-bind="value: selectedBrandId, options: brands, optionsText: 'label', optionsValue: 'id', valueAllowUnset: true"></select>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right"></div>
                        </div>

                        <div class="w-list-results taller">
                            <table class="list-results list-sections">
                                <thead>
                                    <tr>
                                        <th><span>Device</span></th>
                                        <th><span>Referrer</span></th>
                                        <th><span>Geo</span></th>
                                        <th><span>Permalink</span></th>
                                        <th><span>Status</span></th>
                                        <th><span>Actions</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: rules() -->
                                    <tr class="cursor" data-bind="click: function() { $parent.onOpenEdit($data) }">
                                        <td><span data-bind="text: $parent.formatDevice($data.device)"></span></td>
                                        <td><span data-bind="text: $parent.formatReferrer($data.referrer)"></span></td>
                                        <td><span data-bind="text: $parent.formatGeos($data.geos)"></span></td>
                                        <td><span data-bind="text: $parent.formatPermalink($data.permalinkPattern)"></span></td>
                                        <td><span data-bind="text: $data.isEnabled ? 'Enabled' : 'Disabled'"></span></td>
                                        <td>
                                            <button type="button" class="btn" data-bind="click: function(data, event) { $parent.onToggleRule($data, event) }, text: $data.isEnabled ? 'Disable' : 'Enable'"></button>
                                            <button type="button" class="btn" data-bind="click: function(data, event) { $parent.onDeleteRule($data, event) }">Delete</button>
                                        </td>
                                    </tr>
                                    <!-- /ko -->
                                    <!-- ko if: rules().length === 0 -->
                                    <tr>
                                        <td colspan="6"><span>No brand-specific rules for this brand.</span></td>
                                    </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isCreateOpen()}">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Add brand-specific rule</h3>
                            <button type="button" data-bind="event: { click: onCloseCreate }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Device</label>
                                <div class="w-input">
                                    <select data-bind="value: create_device, options: deviceOptions, optionsText: 'label', optionsValue: 'value', enable: !deviceAndReferrerLocked()"></select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Referrer</label>
                                <div class="w-input">
                                    <select data-bind="value: create_referrer, options: referrerOptions, optionsText: 'label', optionsValue: 'value', enable: !deviceAndReferrerLocked()"></select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Geo</label>
                                <div class="w-input">
                                    <select data-bind="value: create_geo, options: geos, optionsText: 'name', optionsValue: 'codeName', optionsCaption: 'Any geo', valueAllowUnset: true"></select>
                                </div>
                                <p class="form-text">Optional. Choose Any geo to match all countries.</p>
                            </div>
                            <div class="form-group" data-bind="css: {'is-error' : permalinkError()}">
                                <label class="form-label">Permalink</label>
                                <div class="w-input">
                                    <input type="text" class="input-text" placeholder="*/profile*" data-bind="value: create_permalinkPattern, valueUpdate: 'input'">
                                </div>
                                <span class="form-error" data-bind="text: permalinkError()"></span>
                                <p class="form-text" data-bind="visible: !create_permalinkPattern() || create_permalinkPattern().trim() === ''">
                                    No permalink is set. This rule matches any permalink for Desktop Direct traffic in the selected geos.
                                </p>
                            </div>
                            <div class="form-group" data-bind="visible: generalError()">
                                <span class="form-error" data-bind="text: generalError()"></span>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button data-bind="click: onCloseCreate" type="button" class="btn">Cancel</button>
                            <button data-bind="click: onSubmitCreate" type="button" class="btn highlight">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isEditOpen()}">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Edit brand-specific rule</h3>
                            <button type="button" data-bind="event: { click: onCloseEdit }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Device</label>
                                <div class="w-input">
                                    <select data-bind="value: edit_device, options: deviceOptions, optionsText: 'label', optionsValue: 'value', enable: !deviceAndReferrerLocked()"></select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Referrer</label>
                                <div class="w-input">
                                    <select data-bind="value: edit_referrer, options: referrerOptions, optionsText: 'label', optionsValue: 'value', enable: !deviceAndReferrerLocked()"></select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Geo</label>
                                <div class="w-input">
                                    <select data-bind="value: edit_geo, options: geos, optionsText: 'name', optionsValue: 'codeName', optionsCaption: 'Any geo', valueAllowUnset: true"></select>
                                </div>
                                <p class="form-text">Optional. Choose Any geo to match all countries.</p>
                            </div>
                            <div class="form-group" data-bind="css: {'is-error' : permalinkError()}">
                                <label class="form-label">Permalink</label>
                                <div class="w-input">
                                    <input type="text" class="input-text" placeholder="*/profile*" data-bind="value: edit_permalinkPattern, valueUpdate: 'input'">
                                </div>
                                <span class="form-error" data-bind="text: permalinkError()"></span>
                                <p class="form-text" data-bind="visible: !edit_permalinkPattern() || edit_permalinkPattern().trim() === ''">
                                    No permalink is set. This rule matches any permalink for Desktop Direct traffic in the selected geos.
                                </p>
                            </div>
                            <div class="form-group" data-bind="visible: generalError()">
                                <span class="form-error" data-bind="text: generalError()"></span>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button data-bind="click: onCloseEdit" type="button" class="btn">Cancel</button>
                            <button data-bind="click: onSubmitEdit" type="button" class="btn highlight">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    protected initPartial() {

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('suspicious-rules');
        this.getTemplateViewModel().selectedBrandId.subscribe(() => {
            this.onBrandChange();
        });
    }

    private normalizeBrandId(idBrand) {

        const parsed = parseInt(idBrand, 10);
        return parsed > 0 ? parsed : null;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/suspiciousRules_template.ts